// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.Button {
  display: flex;
  border-radius: var(--buttonBorderRadius);
  color: var(--whiteColour);
}

.button.MuiButton-root,
.button.MuiButton-root {
  border-radius: var(--buttonBorderRadius);
  text-transform: none;
  font-family: var(--default-FontName);
  /* changed from Segoe UI to branding */
  font-weight: var(--header-FontWeight);
  font-size: var(--default-FontSize);
  padding: 5px 15px;
  min-width: 90px !important;
  min-height: 32px !important;
  background-color: var(--button-color);
  height: 40px;
}

.button.MuiButton-root,
.button.MuiButton-root:hover {
  background-color: var(--button-color);
  color: var(--button-secondary-color);
  letter-spacing: var(--font-letter-space);
  cursor: pointer;
}

.confirmFooterButtons .button.MuiButton-root,
.confirmFooterButtons .button.MuiButton-root:hover {
  border: 1px solid var(--button-color);
}

.button.MuiButton-secondary,
.button.MuiButton-secondary:hover {
  color: var(--button-color);
  border: 1px solid var(--button-color);
  background-color: var(--button-secondary-color);
}

.btn--primary.button.MuiButton-root:disabled {
  background-color: var(--button-disabled-color) !important;
  color: var(--button-secondary-color) !important;
  letter-spacing: var(--font-letter-space);
  /* padding: 5px 15px; */
  /* border: 1px solid var(--button-disabled-color); */
  /*Commenting this due to contradiction of width for disable border and enable border*/
}

.MuiButton-secondary.button.MuiButton-root:disabled {
  background-color: var(--button-secondary-color);
  color: var(--button-disabled-color);
  letter-spacing: var(--font-letter-space);
  border: 1px solid var(--button-disabled-color);
}

.button.btn--secondary,
.button.btn--secondary.MuiButton-root:hover {
  color: var(--button-color);
  border: 1px solid var(--button-color);
  background-color: var(--button-secondary-color);
  margin-right: 10px;
}

.btn--secondary.button.MuiButton-root:disabled {
  /* Changed background and fore-color for secondary disabled button due to secondary disable and primary disabled shows similar design */
  color: var(--button-disabled-color);
  border: 1px solid var(--button-disabled-color);
  background-color: var(--button-secondary-color);
}

.btn--secondary.button.MuiButton-root:disabled svg path,
.MuiButton-secondary.button.MuiButton-root:disabled svg path {
  fill: var(--button-disabled-color);
  stroke: var(--button-disabled-color);
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/button/Button.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;EAEE,wCAAwC;EACxC,oBAAoB;EACpB,oCAAoC;EACpC,sCAAsC;EACtC,qCAAqC;EACrC,kCAAkC;EAClC,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,YAAY;AACd;;AAEA;;EAEE,qCAAqC;EACrC,oCAAoC;EACpC,wCAAwC;EACxC,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,yDAAyD;EACzD,+CAA+C;EAC/C,wCAAwC;EACxC,uBAAuB;EACvB,oDAAoD;EACpD,qFAAqF;AACvF;;AAEA;EACE,+CAA+C;EAC/C,mCAAmC;EACnC,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;;EAEE,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,uIAAuI;EACvI,mCAAmC;EACnC,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;AACtC","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.Button {\n  display: flex;\n  border-radius: var(--buttonBorderRadius);\n  color: var(--whiteColour);\n}\n\n.button.MuiButton-root,\n.button.MuiButton-root {\n  border-radius: var(--buttonBorderRadius);\n  text-transform: none;\n  font-family: var(--default-FontName);\n  /* changed from Segoe UI to branding */\n  font-weight: var(--header-FontWeight);\n  font-size: var(--default-FontSize);\n  padding: 5px 15px;\n  min-width: 90px !important;\n  min-height: 32px !important;\n  background-color: var(--button-color);\n  height: 40px;\n}\n\n.button.MuiButton-root,\n.button.MuiButton-root:hover {\n  background-color: var(--button-color);\n  color: var(--button-secondary-color);\n  letter-spacing: var(--font-letter-space);\n  cursor: pointer;\n}\n\n.confirmFooterButtons .button.MuiButton-root,\n.confirmFooterButtons .button.MuiButton-root:hover {\n  border: 1px solid var(--button-color);\n}\n\n.button.MuiButton-secondary,\n.button.MuiButton-secondary:hover {\n  color: var(--button-color);\n  border: 1px solid var(--button-color);\n  background-color: var(--button-secondary-color);\n}\n\n.btn--primary.button.MuiButton-root:disabled {\n  background-color: var(--button-disabled-color) !important;\n  color: var(--button-secondary-color) !important;\n  letter-spacing: var(--font-letter-space);\n  /* padding: 5px 15px; */\n  /* border: 1px solid var(--button-disabled-color); */\n  /*Commenting this due to contradiction of width for disable border and enable border*/\n}\n\n.MuiButton-secondary.button.MuiButton-root:disabled {\n  background-color: var(--button-secondary-color);\n  color: var(--button-disabled-color);\n  letter-spacing: var(--font-letter-space);\n  border: 1px solid var(--button-disabled-color);\n}\n\n.button.btn--secondary,\n.button.btn--secondary.MuiButton-root:hover {\n  color: var(--button-color);\n  border: 1px solid var(--button-color);\n  background-color: var(--button-secondary-color);\n  margin-right: 10px;\n}\n\n.btn--secondary.button.MuiButton-root:disabled {\n  /* Changed background and fore-color for secondary disabled button due to secondary disable and primary disabled shows similar design */\n  color: var(--button-disabled-color);\n  border: 1px solid var(--button-disabled-color);\n  background-color: var(--button-secondary-color);\n}\n\n.btn--secondary.button.MuiButton-root:disabled svg path,\n.MuiButton-secondary.button.MuiButton-root:disabled svg path {\n  fill: var(--button-disabled-color);\n  stroke: var(--button-disabled-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
